<div class="plm-page">
  <header class="plm-header">
    <div>
      <h1>Acceptance, WCC & handover</h1>
      <p>Layer tests, work completion certificates, invoice links from accepted work, and O&amp;M handover packages.</p>
    </div>
  </header>

  <div class="plm-toolbar">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="projectId" (selectionChange)="onProject()">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.project_name || p.project_identifier || p.id }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-tab-group>
    <mat-tab label="Acceptance tests">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addTest()">
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <mat-select [(ngModel)]="testForm.work_location_id" name="tl">
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Work item</mat-label>
            <mat-select [(ngModel)]="testForm.pavement_work_item_id" name="twi">
              <mat-option *ngFor="let w of workItems" [value]="w.id">{{ w.layer_label }} &#64; {{ w.location_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Test type</mat-label>
            <mat-select [(ngModel)]="testForm.test_type" name="tt">
              <mat-option value="density">Density</mat-option>
              <mat-option value="thickness">Thickness</mat-option>
              <mat-option value="iri">IRI</mat-option>
              <mat-option value="compaction">Compaction</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Result</mat-label>
            <input matInput type="number" [(ngModel)]="testForm.result_value" name="tr" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Pass</mat-label>
            <mat-select [(ngModel)]="testForm.pass" name="tp">
              <mat-option [value]="true">Pass</mat-option>
              <mat-option [value]="false">Fail</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Record</button>
        </form>
        <table mat-table [dataSource]="tests">
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">{{ row.test_type }}</td>
          </ng-container>
          <ng-container matColumnDef="val">
            <th mat-header-cell *matHeaderCellDef>Result</th>
            <td mat-cell *matCellDef="let row">{{ row.result_value }} {{ row.uom }}</td>
          </ng-container>
          <ng-container matColumnDef="pass">
            <th mat-header-cell *matHeaderCellDef>Pass</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-pill" [ngClass]="row.pass ? 'status-completed' : 'status-on_hold'">{{ row.pass ? 'Pass' : 'Fail' }}</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['type','val','pass']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['type','val','pass']"></tr>
        </table>
        <p *ngIf="!tests.length" class="empty-msg">No acceptance tests.</p>
      </div>
    </mat-tab>

    <mat-tab label="WCC">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addWcc()">
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <mat-select [(ngModel)]="wccForm.work_location_id" name="wl">
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>WCC no</mat-label>
            <input matInput [(ngModel)]="wccForm.wcc_no" name="wno" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Notes</mat-label>
            <input matInput [(ngModel)]="wccForm.notes" name="wnotes" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Draft WCC</button>
        </form>
        <table mat-table [dataSource]="wccs">
          <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef>No</th>
            <td mat-cell *matCellDef="let row">{{ row.wcc_no }}</td>
          </ng-container>
          <ng-container matColumnDef="st">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row"><span class="status-pill" [ngClass]="'status-' + row.status">{{ row.status }}</span></td>
          </ng-container>
          <ng-container matColumnDef="act">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-button color="primary" *ngIf="row.status === 'draft'" (click)="issue(row)">Issue</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['no','st','act']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['no','st','act']"></tr>
        </table>
        <p *ngIf="!wccs.length" class="empty-msg">No WCCs.</p>
      </div>
    </mat-tab>

    <mat-tab label="Invoice links">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addInvoice()">
          <mat-form-field appearance="outline">
            <mat-label>Invoice id</mat-label>
            <input matInput type="number" [(ngModel)]="invForm.invoice_id" name="iid" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>WCC</mat-label>
            <mat-select [(ngModel)]="invForm.wcc_id" name="iwcc">
              <mat-option *ngFor="let w of wccs" [value]="w.id">{{ w.wcc_no }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <mat-select [(ngModel)]="invForm.work_location_id" name="il">
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Amount</mat-label>
            <input matInput type="number" [(ngModel)]="invForm.amount" name="iamt" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Link</button>
        </form>
        <table mat-table [dataSource]="invoices">
          <ng-container matColumnDef="inv">
            <th mat-header-cell *matHeaderCellDef>Invoice</th>
            <td mat-cell *matCellDef="let row">{{ row.invoice_id }}</td>
          </ng-container>
          <ng-container matColumnDef="wcc">
            <th mat-header-cell *matHeaderCellDef>WCC</th>
            <td mat-cell *matCellDef="let row">{{ row.wcc_id }}</td>
          </ng-container>
          <ng-container matColumnDef="amt">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let row">{{ row.amount }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['inv','wcc','amt']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['inv','wcc','amt']"></tr>
        </table>
        <p *ngIf="!invoices.length" class="empty-msg">No invoice links.</p>
      </div>
    </mat-tab>

    <mat-tab label="Handover">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addHandover()">
          <mat-form-field appearance="outline">
            <mat-label>Receiving authority</mat-label>
            <input matInput [(ngModel)]="hoForm.receiving_authority" name="auth" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Date</mat-label>
            <input matInput type="date" [(ngModel)]="hoForm.handover_date" name="hdate" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>O&amp;M vendor id</mat-label>
            <input matInput type="number" [(ngModel)]="hoForm.om_contractor_vendor_id" name="omv" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Notes</mat-label>
            <input matInput [(ngModel)]="hoForm.notes" name="hnotes" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Create package</button>
        </form>
        <table mat-table [dataSource]="handovers">
          <ng-container matColumnDef="auth">
            <th mat-header-cell *matHeaderCellDef>Authority</th>
            <td mat-cell *matCellDef="let row">{{ row.receiving_authority }}</td>
          </ng-container>
          <ng-container matColumnDef="st">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row"><span class="status-pill" [ngClass]="'status-' + row.status">{{ row.status }}</span></td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['auth','st']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['auth','st']"></tr>
        </table>
        <p *ngIf="!handovers.length" class="empty-msg">No handover packages.</p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
